import { Component } from 'react';
import LoginBuilder from './LoginBuilder';
import TableBuilder from './TableBuilder';
import PropTypes from 'prop-types';
import MenuBuilder from './MenuBuilder';
import FormBuilder from './FormBuilder';

class Body extends Component {

    render() {
        return (
            this.props.toShow === 'login' ?
                <LoginBuilder />
                : this.props.toShow === 'table' ?
                    <TableBuilder />
                    : this.props.toShow === 'menu' ?
                        <MenuBuilder />
                        : this.props.toShow === 'form' ?
                            < FormBuilder />
                            : <></>
        );
    }
}

Body.propTypes = {
    toShow: PropTypes.string.isRequired
}

export default Body;